import React from 'react'
import { Form } from 'react-bootstrap';
import { Control, Controller } from 'react-hook-form';
import Select, { SingleValue } from 'react-select';

type SelectOption = { label: string; value: string };

const reportOptions: SelectOption[] = [
    { label: "Agent Report", value: "report_agent" },
    { label: "Room Report", value: "room_report" },
    { label: "Daily Report", value: "daily_report" },
    { label: "Sales Report", value: "sales_report" },
    { label: "Country Report", value: "country_report" },
    { label: "Reservation Last 12 Month Report", value: "report_sales_monthly" },
    { label: "Sales Last 12 Month Report", value: "report_reservation" }
];

interface ReportTypeComponentProps {
    control: Control<any>;
    setReportType: React.Dispatch<React.SetStateAction<"country_report" | "daily_report" | "sales_report" | "report_sales_monthly" | "report_reservation" | "report_agent" | "room_report">>;
}

const ReportTypeComponent: React.FC<ReportTypeComponentProps> = ({ control, setReportType }) => {
    return (
        <div>
            <Form.Label className="me-2">Select Report Type:</Form.Label>
            <Controller
                name="report_type"
                control={control}
                render={({ field }) => (
                    <Select<SelectOption>
                        {...field}
                        options={reportOptions}
                        placeholder="Select Report Type"
                        value={reportOptions.find((option) => option.value === field.value) || null}  // ✅ Ensure value is an object
                        onChange={(selectedOption: SingleValue<SelectOption>) => {
                            field.onChange(selectedOption ? selectedOption.value : "");  // ✅ Ensure proper value update
                            setReportType(selectedOption?.value as "country_report" | "daily_report" | "sales_report" | "report_sales_monthly" | "report_reservation" | "report_agent" | "room_report");
                        }}
                        getOptionLabel={(e) => e.label}
                        getOptionValue={(e) => e.value}
                    />
                )}
            />
        </div>
    )
}

export default ReportTypeComponent